import { render, staticRenderFns } from "./AdminRegister.vue?vue&type=template&id=7ec2f744&"
import script from "./AdminRegister.vue?vue&type=script&lang=ts&"
export * from "./AdminRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports